// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__Ru6wc","tab":"ProcedureTabs_tab__1pq-1"};